export default __webpack_public_path__ + "static/media/f975e983f80f84b9.73dea2990c8850edebbf6bce3f0ebf73.svg";